<script setup>
import { HomeIcon } from '@heroicons/vue/solid'
import {Link, usePage} from '@inertiajs/inertia-vue3'
import {computed} from "vue";

const themeColor = computed(() => usePage().props.value.theme_color);

defineProps({
    pages: Object
})

</script>

<template>
    <nav class="bg-white border-b border-gray-200 flex" aria-label="Breadcrumb">
        <ol role="list" class="max-w-screen-xl w-full mx-auto px-4 flex space-x-4 sm:px-6 lg:px-8">
            <li class="flex">
                <div class="flex items-center">
                    <Link href="/" class="text-gray-500 hover:text-gray-900">
                        <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
                        <span class="sr-only">Home</span>
                    </Link>
                </div>
            </li>
            <li v-for="page in pages" :key="page.title" class="flex">
                <div class="flex items-center">
                    <svg :style="{color: themeColor}" class="flex-shrink-0 w-6 h-full text-orange-400" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                    <Link  :href="page.url" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-900" :aria-current="page.current ? 'page' : undefined">{{ page.title }}</Link>
                </div>
            </li>
        </ol>
    </nav>
</template>
